import { useQuery } from 'react-query'
import ClimaCheckService, { ClimaCheckFeedType } from '~/api/services/climaCheck'
import { onError } from '~/utils/helpers'

const getClimaChOptions = (data?) => useQuery(
  'clima-check-options',
  () => ClimaCheckService.getClimaChOptions(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaCh = (data?) => useQuery(
  'clima-check-data',
  () => ClimaCheckService.getClimaChData(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaChCount = (data?) => useQuery(
  'clima-check-count',
  () => ClimaCheckService.getClimaChCount(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerGroups = (id, data?) => useQuery(
  'clima-check-farmer-groups',
  () => ClimaCheckService.getClimaChFarmerGroups(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmers = (id, data?) => useQuery(
  'clima-check-farmers',
  () => ClimaCheckService.getClimaChFarmers(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaChEnergyData = (id, type: ClimaCheckFeedType, data?) => useQuery(
  'clima-check-energy-data',
  () => ClimaCheckService.getClimaChEnergyData(id, type, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimateCheckList = (enabled) => useQuery(
  'climate-check-list',
  () => enabled && ClimaCheckService.getClimateCheckList(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const ClimaCheckQuery = {
  getClimaChOptions,
  getClimaCh,
  getClimaChCount,
  getFarmerGroups,
  getFarmers,
  getClimaChEnergyData,
  getClimateCheckList
}

export default ClimaCheckQuery